import { useEffect, useRef } from "react";

import { useAppDispatch, useAppSelector } from "~/hooks/reduxHooks";
import { dequeueAction, recordExecutedAction } from "~/store/fernieActionSlice";
import { startTour } from "~/store/walkthroughSlice";

const useFernieWalkthroughHandler = (): void => {
	const headAction = useAppSelector((state) => state.fernieAction.pendingActions[0]);
	const status = useAppSelector((state) => state.walkthrough.status);
	const activeTourId = useAppSelector((state) => state.walkthrough.activeTourId);
	const dispatch = useAppDispatch();
	const previousStatus = useRef(status);
	const previousTourId = useRef(activeTourId);

	useEffect(() => {
		if (headAction?.type !== "startWalkthrough") return;
		dispatch(startTour({ tourId: headAction.tourId }));
		dispatch(recordExecutedAction(headAction));
		dispatch(dequeueAction());
	}, [headAction]);

	useEffect(() => {
		const wasRunning = previousStatus.current === "running";
		const endedTourId = previousTourId.current;
		previousStatus.current = status;
		previousTourId.current = activeTourId;
		if (!wasRunning || status === "running" || !endedTourId) return;
		const outcome = status === "completed" ? "completed" : "abandoned";
		dispatch(recordExecutedAction({ outcome, tourId: endedTourId, type: "startWalkthrough" }));
	}, [status, activeTourId]);
};

export default useFernieWalkthroughHandler;
